
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[store_name]/[slug]",
      function () {
        return require("private-next-pages/[store_name]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[store_name]/[slug]"])
      });
    }
  